"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var Tabs = function (_super) {
  __extends(Tabs, _super);

  function Tabs() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onTabItemSelect = function (item) {
      if (_this.props.onTabSelect) {
        _this.props.onTabSelect(item);
      }
    };

    return _this;
  }

  Tabs.prototype.render = function () {
    return react_1.default.createElement(react_native_1.View, {
      style: [theme_pricing_system_1.pricingStyles.tabsViewStyle, this.props.viewStyle]
    }, this.renderTabItems());
  };

  Tabs.prototype.renderTabItems = function () {
    var _this = this;

    return this.props.tabItems.map(function (item) {
      if (item.value === _this.props.selectedTabValue) {
        return _this.renderItemSelected(item);
      }

      return _this.renderItemUnselected(item);
    });
  };

  Tabs.prototype.renderItemSelected = function (item) {
    return react_1.default.createElement(react_native_1.View, {
      key: item.value
    }, react_1.default.createElement(react_native_1.Text, {
      style: theme_pricing_system_1.pricingStyles.tabItemSelectedTextStyle
    }, item.text));
  };

  Tabs.prototype.renderItemUnselected = function (item) {
    var _this = this;

    var onPress = function onPress() {
      return _this.onTabItemSelect(item);
    };

    return react_1.default.createElement(react_native_1.TouchableOpacity, {
      key: item.value,
      onPress: onPress,
      accessibilityRole: "button"
    }, react_1.default.createElement(react_native_1.Text, {
      style: theme_pricing_system_1.pricingStyles.tabItemTextStyle
    }, item.text));
  };

  return Tabs;
}(react_1.default.Component);

exports.Tabs = Tabs;